<template>
  <div>
    <basic-list
      :fields="fields"
      :loading="state.loading"
      :total="state.total"
      :list="state.list"
      :table-h="tableH"
      :page-index="state.pageIndex"
      :page-size="state.pageSize"
      :page-index-change="pageIndexChange"
      :show-action-col="false"
      :selection-change="selectionChange"
      row-key="id"
      :page-size-change="pageSizeChange"
      :tooltip-effect="'dark'"
      :cellClassNames="['cell-overflow-two-line']"
      :index-locked="false"
      :index-align="'left'"
      :index-col-width="48"
      :indexClassName="'min-index-cloumn'"
    >
    </basic-list>
    <OperationLogDrawer :data="detail" :visible="drawerVisible" @close="onCloseDrawer"/>
  </div>
</template>

<script>
import ExactList from "@/mixins/exactList";
import OperationLogDrawer from "./drawer.vue";
export default {
  mixins: [ExactList],
  components: { OperationLogDrawer },
  data() {
    return {
      drawerVisible: false,
      detail: undefined,

      pageIndexChangeFlag: false,
      fields: [
        { key: "appCode", name: `${this.$t('language.5o6u3wttipk0')}`, align: "left", width: 150,
          render: (h, { row }) => (
            <el-tooltip placement="top" transition="none" open-delay={ 500 }>
              <div slot="content">{ row.appCode }</div>
              <div>{row.appCode}</div>
            </el-tooltip>
          )
        },
        { key: "granteeCode", name: `${this.$t('language.5o6u3wttjm00')}`, align: "left",width: 150,
          render: (h, { row }) => (
            <el-tooltip placement="top" transition="none" open-delay={ 500 }>
              <div slot="content">{ row.granteeCode }</div>
              <div>{row.granteeCode}</div>
            </el-tooltip>
          )
        },
        { key: "granteeName", name: `${this.$t('language.5o6u3wttjrg0')}`, align: "left",width: 150,
          render: (h, { row }) => (
            <el-tooltip placement="top" transition="none" open-delay={ 500 }>
              <div slot="content">{ row.granteeName }</div>
              <div>{row.granteeName}</div>
            </el-tooltip>
          )
        },
        { key: "workType", name: `${this.$t('language.5o6u3wttjuo0')}`, align: "left",
          render: (h, { row }) => (
            <el-tooltip placement="top" transition="none" open-delay={ 500 }>
              <div slot="content">{ row.workType }</div>
              <div>{row.workType}</div>
            </el-tooltip>
          )
        },
        { key: "operateType", name: `${this.$t('language.5o6u3wttjxs0')}`, align: "left",
          render: (h, { row }) => (
            <el-tooltip placement="top" transition="none" open-delay={ 500 }>
              <div slot="content">{ row.operateType }</div>
              <div>{row.operateType}</div>
            </el-tooltip>
          )
        },
        { key: "purviewCode", name: `${this.$t('language.5o6u3wttk1c0')}`, align: "left",width: 150,
          render: (h, { row }) => (
            <el-tooltip placement="top" transition="none" open-delay={ 500 }>
              <div slot="content">{ row.purviewCode }</div>
              <div>{row.purviewCode}</div>
            </el-tooltip>
          )
        },
        { key: "purviewName", name: `${this.$t('language.5o6u3wttk4o0')}`, align: "left",width: 170,
          render: (h, { row }) => (
            <el-tooltip placement="top" transition="none" open-delay={ 500 }>
              <div slot="content">{ row.purviewName }</div>
              <div>{row.purviewName}</div>
            </el-tooltip>
          )
        },
        { key: "opBeforeValue", name: `${this.$t('language.5o6u3wttk7o0')}`, align: "left", width: 150,
          render: (h, { row }) => {
            if (row.opBeforeValue || row.opAfterValue) {
              if (row.opBeforeValue !== '-' || row.opAfterValue !== '-') {
                return (
                  <el-button class="fs-14 fw-n" type="text" onClick={() => this.onContent(row)}>{`${this.$t('language.5o6u3w5ti190')}`}</el-button>
                )
              }
            }
            return <span>-</span>
          }
        },
        { key: "opPath", name: `${this.$t('language.5o6u3wttkb00')}`, align: "left",
          render: (h, { row }) => (
            <el-tooltip placement="top" transition="none" open-delay={ 500 }>
              <div slot="content">{ row.opPath }</div>
              <div>{row.opPath}</div>
            </el-tooltip>
          )
        },
        { key: "createUser", name: `${this.$t('language.5o6u3wttkdw0')}`, align: "left",
          render: (h, { row }) => (
            <el-tooltip placement="top" transition="none" open-delay={ 500 }>
              <div slot="content">{ row.createUser }</div>
              <div>{row.createUser}</div>
            </el-tooltip>
          )
        },
        {
          key: "createTime",
          name: `${this.$t('language.5o6u3wttkgk0')}`,
          align: "left",
          render: (h, { row }) => (
            <el-tooltip placement="top" transition="none" open-delay={ 500 }>
              <div slot="content">{ jt.date.format(new Date(row.createTime).getTime()) }</div>
              <div>{ jt.date.format(new Date(row.createTime).getTime()) }</div>
            </el-tooltip>
          )
          // formatter: function (row, column, cellValue, index) {
          //   return jt.date.format(new Date(cellValue).getTime());
          // },
        },
        { key: "remark", name: `${this.$t('language.5o6otz4p1w00')}`, align: "left",
          render: (h, { row }) => (
            <el-tooltip placement="top" transition="none" open-delay={ 500 }>
              <div slot="content">{ row.remark }</div>
              <div>{row.remark}</div>
            </el-tooltip>
          )
        },
      ],
    };
  },
  methods: {
    onContent(row) {
      this.detail = row;
      this.drawerVisible = true
    },
    onCloseDrawer(){
      this.drawerVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>

